export const INFO : IPackageTeaserCard = {
    headline: 'Unknown',
    subHeadline: 'Unknown',
    icon: '',
    link: '/'
}
